import NotLoggedInContainer from '../base/NotLoggedInContainer'
import { styled, Typography } from '@mui/material'
import OpaqueButton from '../base/buttons/OpaqueButton'
import { navigationPush } from '../../navigation/studentPages'
import { useRouter } from 'next/router'
import notLoggedInPages from '../../navigation/notLoggedInPages'

const Container = styled('div')({
  padding: '32px',
  maxWidth: '700px',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  rowGap: '16px'
})

const TextLines = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '4px',
})

const LinkExpired = () => {
  const router = useRouter()
  return (
    <NotLoggedInContainer>
      <Container>
        <Typography variant={'h3'}>
          Link Expired
        </Typography>
        <TextLines>
          <Typography variant={'body1'}>
            This link has already been used to create an account. Please try the following.
          </Typography>
          <Typography variant={'body1'}>
            (1) try logging in using the email address to which this link was sent,
          </Typography>
          <Typography variant={'body1'}>
            (2) if you forgot your password, you can change it below, or
          </Typography>
          <Typography variant={'body1'}>
            (3) if you still can&apos;t access your account, email us at support@findingfocus.app
          </Typography>
        </TextLines>
        <OpaqueButton
          title={'Forgot Password'}
          onClick={() => {
            navigationPush(notLoggedInPages.forgotPassword.getRoute(), router, notLoggedInPages.forgotPassword.v1)
          }}
        />
      </Container>
    </NotLoggedInContainer>
  )
}

export default LinkExpired
